var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 39.25,
    height: 39.25,
    rx: 2.625,
    fill: "#F3F4F5",
    stroke: "#DBDAE3",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8245 30C25.2138 30 30.3556 22.319 30.3556 15.6594C30.3556 15.4386 30.3556 15.2247 30.3556 15.0107C31.3532 14.2971 32.2143 13.4138 32.8986 12.4021C31.9663 12.8103 30.9772 13.0778 29.9644 13.1957C31.024 12.5724 31.8203 11.5922 32.207 10.4353C31.2003 11.0105 30.1017 11.4119 28.9584 11.6223C27.3784 9.93225 24.8411 9.51219 22.7896 10.601C20.7382 11.6898 19.6922 14.0117 20.2467 16.246C16.1404 16.0353 12.3182 14.111 9.73256 10.9529C8.37833 13.2558 9.06964 16.2019 11.3114 17.6815C10.4985 17.6591 9.70291 17.4437 8.99203 17.0535V17.1156C8.99361 19.5147 10.7055 21.5809 13.0859 22.0568C12.3345 22.2605 11.5458 22.2912 10.7805 22.1465C11.4496 24.201 13.3676 25.6074 15.552 25.6454C13.7449 27.0471 11.5132 27.8079 9.21559 27.8054C8.80937 27.8059 8.40348 27.7829 8 27.7364C10.3341 29.2174 13.0504 30.0032 15.8245 30Z",
    fill: "#7F858B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.016ce2e94b7b75fa85f6081cea80dce7.svg";
export { ForwardRef as ReactComponent };